import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { getLabelByValue, mainObjectives } from "../constants/formOptions";
import { toast } from "react-toastify";

function ModalApproveAssessment({ action, isOpen, onClose, onDone }) {
  const [approvedAssessments, setApprovedAssessments] = useState({});
  const [accepted, setAccepted] = useState(null);
  const [description, setDescription] = useState("");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (action && (action?.status === 'approved' || action?.status === 'rejected')) {
      setAccepted(action?.status === 'approved');
      setDescription(action?.rejectionReason || "");
      setDisabled(true);
    }
  }, [action]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleDone = () => {
    if (accepted === null) {
      toast.error("Please approve or reject the proposal.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (accepted === false && !description.trim()) {
      toast.error("Please provide a description if you reject the proposal.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (accepted === true) {
      const requiredCategories = Object.keys(action?.assessments || {});
      const missingApproval = requiredCategories.find(
        (cat) => !approvedAssessments[cat]
      );

      if (missingApproval) {
        toast.error("Please approve a suggestion for each objective.", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
    }

    onDone({ action, accepted, approvedAssessments, description });
    handleClose();
  };

  const resetForm = () => {
    setApprovedAssessments({});
    setAccepted(null);
    setDescription("");
  };

  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={handleClose} className="large">
      <div className="modal-add-data-file">
        <h6>Preassessment Proposal</h6>
        <p>Proposal date: {new Date(action?.createDate).toLocaleDateString()}</p>
        <p>Type of analysis: {action?.type}</p>

        <table style={{
          width: '100%',
          borderSpacing: 0,
          borderCollapse: 'separate',
          borderRadius: 10,
          border: '1px solid black'
        }}>
          <thead style={{ backgroundColor: "#F2F3F4" }}>
            <tr>
              <th>Preassessment Objective</th>
              <th>Preassessment Proposal</th>
            </tr>
          </thead>
          <tbody>
            {action?.assessments &&
              Object.entries(action.assessments).map(([category, suggestions]) => (
                <tr key={category}>
                  <td style={{ verticalAlign: "top" }}>
                    {getLabelByValue(mainObjectives, category)}
                  </td>
                  <td>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {suggestions.map((sugg, i) => {
                        if (!sugg.trim()) return null;
                        const label = i === 0 ? "Suggested" : i === 1 ? "2nd Option" : "3rd Option";
                        return (
                          <label
                            key={`${category}-${i}`}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 10,
                            }}
                          >
                            <span style={{ fontWeight: i === 0 ? "bold" : "normal" }}>
                              {label}: {sugg}
                            </span>
                            <input
                              type="radio"
                              name={`selected-${category}`}
                              checked={approvedAssessments[category] === sugg}
                              onChange={() =>
                                setApprovedAssessments((prev) => ({
                                  ...prev,
                                  [category]: sugg,
                                }))
                              }
                            />
                          </label>
                        );
                      })}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {disabled ? (
          <p>Proposal status: <b>{action?.status}</b></p>
        ) : (
          <p>
            Do you want to continue with this proposal?
            <input
              type="radio"
              name="acceptedProposal"
              value="yes"
              style={{
                width: '20px',
                height: '20px',
                margin: '15px'
              }}
              checked={accepted === true}
              onChange={() => setAccepted(true)}
            /> Yes
            <input
              type="radio"
              name="acceptedProposal"
              value="no"
              style={{
                width: '20px',
                height: '20px',
                margin: '15px'
              }}
              checked={accepted === false}
              onChange={() => setAccepted(false)}
            /> No
          </p>
        )}
        Description<br />
        <textarea
          placeholder="less than 100 words"
          className="description"
          onChange={(e) => setDescription(e.target.value)}
          defaultValue={description}
          disabled={disabled}
        />
      </div>

      <div className="modal-actions" style={{ justifyContent: "flex-end" }}>
        <button className="button-outline outline" onClick={handleClose}>
          Cancel
        </button>
        {!disabled && <button className="button-dark" onClick={handleDone}>
          Done
        </button>}
      </div>
    </Modal>
  );
}

export default ModalApproveAssessment;
